import {
  AssignmentBadRequestError,
  AssignmentBodyNotValidError,
  AssignmentDoesNotExistError,
  UserNotPermittedError
} from "@seneca/assignments-service-client";
import { ErrorCodes } from "@seneca/assignments-service-consts";

export default function errorTranslator(error: Error): string {
  if (typeof error === "string") return error;

  if (error instanceof AssignmentBadRequestError) {
    const explanation = getErrorCodeExplanation(error.message as ErrorCodes);
    if (explanation) {
      return `Sorry, ${explanation}. Please retry or get in touch if the problem persists.`;
    }
  }

  if (error instanceof AssignmentDoesNotExistError) {
    return `Sorry, the assignment doesn't exist.`;
  }

  if (error instanceof UserNotPermittedError)
    return "Sorry, you're not allowed to perform this action.";

  if (
    error instanceof AssignmentBodyNotValidError &&
    error.message.includes("School access has expired")
  ) {
    return "Sorry, your school sync has expired.";
  }

  return "Unknown error occurred! Please retry or get in touch if the problem persists. ";
}

function getErrorCodeExplanation(errorCode?: ErrorCodes) {
  switch (errorCode) {
    case ErrorCodes.ASSIGNEES_COUNT_EXCEEDED:
      return "there are too many students in this assignment";
    case ErrorCodes.ASSIGNMENTS_COUNT_EXCEEDED:
      return "there are too many assignments in this class";
    case ErrorCodes.EXAM_QUESTIONS_COUNT_EXCEEDED:
      return "there are too many Exam Questions in this assignment";
    case ErrorCodes.SECTIONS_COUNT_EXCEEDED:
      return "there are too many sections in this assignment";
  }
  return undefined;
}
